export default __webpack_public_path__ + "static/media/Sarah@2x.b3d2e7c7.jpg";